var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProfileIcon = function SvgProfileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-6080 -3664.059 82 81.765",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-12345 {\n        fill: none;\n        stroke-width: 2px;\n      }\n\n      .cls-09876 {\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-89",
    transform: "translate(-6079 -3663.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse-19",
    className: "cls-12345",
    d: "M40,0A39.883,39.883,0,1,1,0,39.883,39.941,39.941,0,0,1,40,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-66",
    transform: "translate(11.226 16.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-64",
    className: "cls-09876",
    d: "M28.773,63.94A39.733,39.733,0,0,1,0,51.761c6.217-11.4,17.092-18.208,29.091-18.208,11.812,0,22.6,6.645,28.851,17.776a40.187,40.187,0,0,1-19.75,11.5A39.729,39.729,0,0,1,28.773,63.94Zm0-34.818a14.561,14.561,0,1,1,14.6-14.561A14.6,14.6,0,0,1,28.773,29.121Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profileIcon.3f71d238.svg";
export { ForwardRef as ReactComponent };